import { getSentryGlobalScope } from '@gitbook/util-debug';

/**
 * Set the global context in Sentry.
 */
export function setSentryContext(contexts: {
    [contextName: string]: Record<string, unknown> | null;
}) {
    const scope = getSentryGlobalScope();
    for (const [contextName, contextValue] of Object.entries(contexts)) {
        scope.setContext(contextName, contextValue);
    }

    return () => {
        for (const contextName of Object.keys(contexts)) {
            scope.setContext(contextName, null);
        }
    };
}
